import React from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: "100%",
      flexDirection: "column",
    },
    loader: {},
    line: {
      animation: `$expand 1s ease-in-out infinite`,
      borderRadius: 24,
      display: "inline-block",
      transformOrigin: "center center",
      margin: "0 3px",
      width: 1,
      height: 25,
      "&:nth-child(1)": {
        background: "#27ae60",
      },
      "&:nth-child(2)": {
        animationDelay: "180ms",
        background: "#f1c40f",
      },
      "&:nth-child(3)": {
        animationDelay: "360ms",
        background: "#e67e22",
      },
      "&:nth-child(4)": {
        animationDelay: "540ms",
        background: "#2980b9",
      },
    },
    "@keyframes expand": {
      "0%": {
        transform: "scale(1)",
      },
      "25%": {
        transform: "scale(2)",
      },
    },
    logo: {
      marginTop: theme.spacing(3),
    },
  })
);

const LoadingView = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.loader}>
        <div className={classes.line} />
        <div className={classes.line} />
        <div className={classes.line} />
        <div className={classes.line} />
      </div>
      {window.config && window.config.logo1 && (
        <img className={classes.logo} alt="Logo" src={window.config.logo1} />
      )}
    </div>
  );
};

export default LoadingView;
